import * as types from '../constants/ActionTypes';
import {
  CognitoUserPool,
  CognitoUser,
  CognitoIdentityCredentials,
  AuthenticationDetails
} from 'amazon-cognito-identity-js';

import config from '../config';
import * as codes from '../constants/AmazonCodes';
import AWS from 'aws-sdk';

import { getCognitoUser } from '../lib/cognitoHelper';

/**
 *
 * @param user {email,password}
 * @param showUserNotConfirmed {fn}
 * @returns {{type, payload: Promise}}
 */
export function authenticate(user, showUserNotConfirmed) {
  console.log("authenticate function");
  return {
    type: types.AUTHENTICATION,
    payload: loginAWS(user.email, user.password).catch(error => {
      if (error.code == codes.UserNotConfirmedException) {
        showUserNotConfirmed(); // Shows the userNotConfirmed Page
      }
      throw error; // Continue with the promise chain as rejected, so the errorReducer can handle it.
    })
  };
}

/**
 * Logout function
 * @param {function} cb executes when promise is resolved.
 * @returns {{type}}
 */
export function logout() {
  const userPool = new CognitoUserPool({
    UserPoolId: config.cognito.USER_POOL_ID,
    ClientId: config.cognito.APP_CLIENT_ID
  });
  try {
    const cognitoUser = userPool.getCurrentUser();

    cognitoUser.signOut();
  } catch (e) {
    console.log(e);
  }
  return { type: types.LOGOUT };
}

export function resetRegister() {
  return { type: types.RESET_REGISTRATION };
}
/**
 * Signup user
 * @param user {CognitoUser}
 * @returns {{type, payload: Promise}}
 */
export function signup(user) {
  return {
    type: types.REGISTRATION,
    payload: signupAWS(user.email, user.password)
  };
}
/**
 * Confirm Registration via confirmCode, provided by Amazon Cognito Service
 * @param user {email,password}
 * @param confirmCode
 * @returns {{type, payload: Promise}}
 */
export function confirm(user, confirmCode) {
  return {
    type: types.CONFIRM_REGISTRATION,
    payload: confirmAWS(user, confirmCode)
  };
}
/**
 * Authenticate
 */
export function authenticateByValidSession(tokens) {
  return { type: types.AUTHENTICATION_BY_VALID_SESSION, payload: tokens };
}

/**
 * Login call to Amzaon Cognito Service
 * @param email
 * @param password
 * @returns {Promise}
 */
function loginAWS(email, password) {
  var authenticationData = {
    Username: email,
    Password: password
  };
  var authenticationDetails = new AuthenticationDetails(authenticationData);
  var poolData = {
    UserPoolId: config.cognito.USER_POOL_ID,
    ClientId: config.cognito.APP_CLIENT_ID
  };
  var userPool = new CognitoUserPool(poolData);
  var userData = {
    Username: email,
    Pool: userPool
  };
  var cognitoUser = new CognitoUser(userData);
  return new Promise((resolve, reject) =>
    cognitoUser.authenticateUser(authenticationDetails, {
      onSuccess: result => {
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
          IdentityPoolId: config.cognito.IDENTITY_POOL_ID,
          Logins: {
            'cognito-idp:us-east-1:523448140097:userpool/us-east-1_QIVs4dvoX': result
              .getIdToken()
              .getJwtToken()
          }
        });

        console.log("resulst login aws",result);
        resolve(result);
      },
      onFailure: err => {
        reject(err);
      }
    })
  );
  /*
  const userPool = new CognitoUserPool({
    UserPoolId: config.cognito.USER_POOL_ID,
    ClientId: config.cognito.APP_CLIENT_ID
  });
  const user = new CognitoUser({Username: email, Pool: userPool});
  const authenticationData = {Username: email, Password: password};
  const authenticationDetails = new AuthenticationDetails(authenticationData);

  return new Promise((resolve, reject) =>
    user.authenticateUser(authenticationDetails, {
      onSuccess: result => resolve(result),
      onFailure: err => reject(err)
    })
  );
*/
}

/**
 * Signup call to Amazon Cognito Service
 * @param email
 * @param password
 * @returns {Promise}
 */
function signupAWS(email, password) {
  const userPool = new CognitoUserPool({
    UserPoolId: config.cognito.USER_POOL_ID,
    ClientId: config.cognito.APP_CLIENT_ID
  });

  return new Promise((resolve, reject) =>
    userPool.signUp(email, password, [], null, (err, result) => {
      if (err) {
        reject(err);
        return;
      }

      resolve(result.user);
    })
  );
}

/**
 * Confirm singup call to Amazon Cognito Service
 * @param user {CognitoUser Obj} (returned by signup)
 * @param confirmationCode
 * @returns {Promise}
 */
function confirmAWS(user, confirmationCode) {
  return new Promise((resolve, reject) =>
    user.confirmRegistration(confirmationCode, true, function(err, result) {
      if (err) {
        reject(err);
        return;
      }
      resolve(result);
    })
  );
}



// WEBPACK FOOTER //
// ./actions/userActions.js